/** @jsxImportSource @emotion/react */
import React, {useState, useEffect} from 'react'
import {WidgetContainer, Graphs} from 'components'
import {useDependency, useResource, useFilter, useCurrentIntervalTime} from 'hooks'
import { Widgets } from './'
import { DEFAULT_WIDGET_REFRESH_MS } from 'constants'
import WindPowerIcon from '@mui/icons-material/WindPower'
import {useSavedFilters} from 'contexts/SavedFiltersContext'

const DEFAULT_FILTER = {
  region: 'NZ'
}

const WindForecastGraph = (props) => {
  const widget = Widgets['wind-forecast-graph']
  const [filter, setFilter] = useFilter(null, 'windforecast')
  const savedFilters = useSavedFilters()
  
  const [intermittent, intermittentActions] = useResource('intermittent')
  
  const updateWidget = () => {
    const {region} = props.filter || filter
    return Promise.all([
      region && intermittentActions.request('generation', {region, generationType: 'WIN'}),
      region && intermittentActions.request('forecast', {region, generationType: 'WIN'}),
    ])
  }
  
  const [loading, result, reload] = useDependency(updateWidget, [filter])
  const currentInterval = useCurrentIntervalTime()
  const lastUpdatedAt = intermittent.forecast?.responseAt
  const [zoom, setZoom] = useState({})
  const zoomCallback = zoom => setZoom(zoom)
  const tooltips = useState(false)

  useEffect(() => {
    const initialFilter = savedFilters.load(widget) || DEFAULT_FILTER
    setFilter({...initialFilter, ...filter})
  }, [])

  return (
    <WidgetContainer
      widget={widget}
      title="Wind Generation Forecast (MW)"
      icon={<WindPowerIcon/>}
      lastUpdatedAt={lastUpdatedAt}
      lastUpdatedAtAddMinutes={0}
      loading={loading}
      onWidgetRefresh={reload}
      widgetAutoRefreshMs={DEFAULT_WIDGET_REFRESH_MS}
      renderFilter={() => <Graphs.RegionFilter subRegions={false} filter={filter} onChange={setFilter} />}
      onFilterSave={() => savedFilters.update(widget, filter)}
      zoom={zoom}
      tooltips={tooltips}
      {...props}
    >
      <Graphs.IntermittentForecast
        generationType="wind"
        generationData={intermittent.generation?.data}
        forecastData={intermittent.forecast?.data}
        zoomCallback={zoomCallback}
        currentInterval={currentInterval}
        tooltips={tooltips}
      />
    </WidgetContainer>
);
}

const styles = {}

export default WindForecastGraph